export const RETURN_REASONS = [
  { value: 64, label: 'Fit - Too small' },
  { value: 32, label: 'Fit - Too large' },
  { value: 2147483648, label: 'Fit - Length' },
  { value: 274877906944, label: 'Quality - Product missing piece' },
  { value: 128, label: 'Quality - Color not as expected' },
  { value: 1024, label: 'Quality - Style not as described on website' },
  { value: 256, label: 'Quality - Fabric not as expected' },
  { value: 32768, label: 'Quality - Incorrect item received' },
  { value: 16384, label: 'Quality - Item arrived damaged' },
  { value: 65536, label: 'Shipping - Item arrived after promised delivery date' },
  { value: 17179869184, label: 'Shipping - Same day delivery window missed' }
];
